// extracted by mini-css-extract-plugin
module.exports = {"label":"e_2s","disc":"e_3s","glyph":"e_4s","labelButton":"e_5s","tip":"e_6s","labelOpen":"e_7s"};